export let selectedFolderNodeScreenReaderOnlyText = "ZG1NAd";
export let ellipsesButtonTitle = "XWYZq";
export default {selectedFolderNodeScreenReaderOnlyText,ellipsesButtonTitle};